import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useReplaceRecommendedItemsWithSimilarLots = () => {
    const hasControl = useAmplitudeExperimentBase(
        AmplitudeExperiments.ReplaceRecommendedItemsWithSimilarLots,
        AmplitudeVariants.ReplaceRecommendedItemsWithSimilarLots.Control
    );

    const hasLastTwoViewedLots = useAmplitudeExperimentBase(
        AmplitudeExperiments.ReplaceRecommendedItemsWithSimilarLots,
        AmplitudeVariants.ReplaceRecommendedItemsWithSimilarLots.LastTwoViewedLots
    );

    const hasLastTwoSavedLots = useAmplitudeExperimentBase(
        AmplitudeExperiments.ReplaceRecommendedItemsWithSimilarLots,
        AmplitudeVariants.ReplaceRecommendedItemsWithSimilarLots.LastTwoSavedLots
    );

    return {
        hasControl,
        hasLastTwoViewedLots,
        hasLastTwoSavedLots,
    };
};
